import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem 0;
`;

export const InfoText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const HelpText = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background-color: ${({ theme }) => theme.backgroundSecondary || '#f5f5f5'};
  border-radius: 8px;
  margin-top: 0.5rem;
`;

export const PhoneInputContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
`;

export const CountrySelector = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1rem;
  border: 1px solid ${({ theme }) => theme.borderColor || 'rgba(255, 255, 255, 0.23)'};
  border-radius: 4px;
  background-color: transparent;
  color: ${({ theme }) => theme.textPrimary || '#fff'};
  cursor: pointer;
  min-width: 100px;
  height: 56px;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.primary || '#ff6b35'};
    background-color: ${({ theme }) => theme.backgroundSecondary || 'rgba(255, 255, 255, 0.05)'};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  @media (max-width: 768px) {
    height: 40px;
    padding: 0.5rem 0.75rem;
    min-width: 85px;
  }
`;

export const CountryFlag = styled.span`
  font-size: 1.5rem;
  line-height: 1;
`;

export const CountryCode = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
`;
